import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { gameStore, GameState } from '../game/store';
import { SHOP_ITEMS } from '../game/world';
export function ShopPanel() {
  const [state, setState] = useState<GameState>(gameStore.getState());
  useEffect(() => gameStore.subscribe(setState), []);
  const handleBuy = (item: (typeof SHOP_ITEMS)[number]) => {
    if (state.gold < item.price) {
      gameStore.addMessage('Insufficient funds. Mrs. Wartbottom is disappointed but not surprised.', 'system');
      return;
    }
    gameStore.setState({
      gold: state.gold - item.price
    });
    gameStore.addItem({
      id: item.id,
      name: item.name,
      description: item.description,
      type: item.type,
      effect: item.effect,
      value: item.value,
      quantity: 1
    });
    gameStore.addMessage(`Purchased: ${item.name}.`, 'loot');
  };
  const handleClose = () => gameStore.setState({
    shopOpen: false
  });
  return <AnimatePresence data-id="element-126">
      {state.shopOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="absolute inset-0 z-40 bg-black/80 backdrop-blur-sm flex items-center justify-center pointer-events-auto p-4" data-id="element-127">
          <motion.div initial={{
        y: 40,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 40,
        opacity: 0
      }} transition={{
        type: 'spring',
        bounce: 0.25
      }} className="bg-gradient-to-b from-amber-950/90 to-black/95 border-2 border-amber-700/60 max-w-2xl w-full" style={{
        boxShadow: '0 0 40px rgba(251,191,36,0.2)'
      }} data-id="element-128">
            {/* Header */}
            <div className="border-b-2 border-amber-700/50 p-5 text-center" data-id="element-129">
              <div className="text-amber-500/70 text-xs uppercase tracking-[0.4em] mb-1" data-id="element-130">
                Merchant's Nook · Floor 1
              </div>
              <div className="text-3xl font-black text-amber-300 uppercase tracking-wide" data-id="element-131">
                Mrs. Wartbottom's Curios
              </div>
              <div className="text-amber-400/60 italic text-sm mt-1" data-id="element-132">
                "Everything priced fairly! For certain values of 'fair.'"
              </div>
            </div>

            {/* Gold indicator */}
            <div className="bg-black/40 px-5 py-2 border-b border-amber-900/40 flex justify-between items-center" data-id="element-133">
              <div className="text-amber-200 uppercase tracking-widest text-sm" data-id="element-134">
                Your Purse
              </div>
              <div className="text-amber-300 font-bold text-xl flex items-center gap-2" data-id="element-135">
                <span data-id="element-136">⦾</span>
                {state.gold} Gold
              </div>
            </div>

            {/* Items */}
            <div className="p-4 space-y-2 max-h-96 overflow-y-auto" data-id="element-137">
              {SHOP_ITEMS.map(item => {
            const canAfford = state.gold >= item.price;
            return <div key={item.id} className="flex items-start gap-4 p-3 border border-amber-900/30 bg-black/40 hover:border-amber-700/60 transition-colors" data-id="element-138">
                    <div className="flex-1" data-id="element-139">
                      <div className="text-amber-200 font-bold uppercase tracking-wider text-sm" data-id="element-140">
                        {item.name}
                      </div>
                      <div className="text-gray-400 italic text-xs mt-1" data-id="element-141">
                        {item.description}
                      </div>
                    </div>
                    <button onClick={() => handleBuy(item)} disabled={!canAfford} className={`px-4 py-2 border-2 uppercase tracking-widest text-xs font-bold whitespace-nowrap transition-colors ${canAfford ? 'border-amber-500/60 text-amber-300 hover:bg-amber-900/30 hover:border-amber-400' : 'border-gray-800 text-gray-700 cursor-not-allowed'}`} data-id="element-142">
                      Buy · ⦾{item.price}
                    </button>
                  </div>;
          })}
            </div>

            {/* Footer */}
            <div className="border-t-2 border-amber-700/50 p-4 flex justify-center" data-id="element-143">
              <button onClick={handleClose} className="px-8 py-2 bg-transparent text-amber-400 border-2 border-amber-600/60 uppercase tracking-[0.2em] font-bold text-sm hover:bg-amber-900/30 transition-colors" data-id="element-144">
                Leave Shop
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}